import { render } from "./JournalEntryHeader.vue?vue&type=template&id=f1ce7240"
import script from "./JournalEntryHeader.vue?vue&type=script&lang=js"
export * from "./JournalEntryHeader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rebecca/Workspace/repositories/mercator/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__